<template lang="pug">
  div
    slot(name="msg")
      .input-feedback.text-danger(v-if="value.$dirty == true && value.required == false && !checkBox") {{ $t("error.isRequired", { fname: name }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.required == false && checkBox && message" v-html="message") 
      .input-feedback.text-danger(v-if="value.$dirty == true && value.valid == false &&  value.minLength == true && value.maxLength == true")  {{ $t("error.invalidPasswordFormat") }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.minLength == false") {{ $t("error.isMinLength", { fname: name, fvalue: value.$params.minLength.min }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.maxLength == false") {{ $t("error.isMaxLength", { fname: name, fvalue: value.$params.maxLength.max }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.minValue == false") {{ $t("error.isMinValue", { fname: name, fvalue: value.$params.minValue.min }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.maxValue == false") {{ $t("error.isMaxValue", { fname: name, fvalue: value.$params.maxValue.max }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.alpha == false") {{ $t("error.isAlpha", { fname: name }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.alphaNum == false") {{ $t("error.isAlphaNum", { fname: name }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.numeric == false") {{ $t("error.isNumeric", { fname: name }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.email == false") {{ $t("error.isEmail", { fname: name }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.ipAddress == false") {{ $t("error.isIpAddress", { fname: name }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.sameAs == false") {{ $t("error.isSameAs", { fname: name, fname2: name2 }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.notSameAs == false") {{ $t("error.notSameAs", { fname: name, fname2: name2 }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.url == false") {{ $t("error.isUrl", { fname: name }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.containAlphaNum == false") {{ $t("error.containAlphaNum", { fname: name }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.selectOption == false") {{ $t("error.selectOption", { fname: name }) }}
      .input-feedback.text-danger(v-if="value.$dirty == true && value.between == false") {{ $t("error.isBetween", { fname: name, min: min, max: max }) }}
  //- .error.w-100
    slot(name="msg")
      small.text-danger.form-text(v-if="!valueThree && !valueTwo && value.$dirty == true && value.required == false") {{ $t("error.isRequired", { fname: name }) }}
      small.text-danger.form-text(v-if="!valueThree && !valueTwo && value.$dirty == true && value.minLength == false") {{ $t("error.isMinLength", { fname: name, fvalue: value.$params.minLength.min }) }}
      small.text-danger.form-text(v-if="!valueTwo && value.$dirty == true && value.maxLength == false") {{ $t("error.isMaxLength", { fname: name, fvalue: value.$params.maxLength.max }) }}
      
      .review-small-text(v-if="!valueThree && valueTwo && (value.$dirty == true || valueTwo.$dirty == true) && (value.required == false || valueTwo.required == false || value.minLength == false || valueTwo.minLength == false || value.maxLength == false || valueTwo.maxLength == false)") {{ $t("error.checkFormat", { fname: name }) }}
      .review-small-text(v-if="valueThree && value.$dirty == true && value.required == false") {{ $t("error.isRequired", { fname: name }) }}
      .review-small-text(v-if="valueThree && value.$dirty == true && value.minLength == false") {{ $t("error.isMinLength", { fname: name, fvalue: value.$params.minLength.min }) }}
      .review-small-text(v-if="valueThree && value.$dirty == true && value.maxLength == false") {{ $t("error.isMaxLength", { fname: name, fvalue: value.$params.maxLength.max }) }}
</template>

<script>
export default {
  props: {
    value: {
      type: Object
    },
    message:{
      type: String
    },
    name: {
      type: String
    },
    name2: {
      type: String
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    valueTwo:{
      type: Object
    },
    valueThree:{
      type: Object
    },
    checkBox:{
      type: Boolean,
      default: false
    }
  }
};
</script>

